import useConfiguration from '@/composables/configuration/configuration'
import useAppState from '@/composables/ui/ui'
import AppError, { APP_ERRORS } from '@/error/appError'

export default function useEnvConfiguration() {
  const envConfiguration = [
    {
      regex: process.env.VUE_APP_DEV_APP_HOSTNAME_REGEX,
      configuration: {
        forumUrl: process.env.VUE_APP_DEV_CONFIGURATION_HOSTNAME,
        widgetUrl: process.env.VUE_APP_DEV_CONFIGURATION_WIDGET_HOSTNAME,
        loginUrl: process.env.VUE_APP_DEV_LOGIN_URL,
        subscriptionUrl: process.env.VUE_APP_DEV_BUY_SUBSCRIPTION_URL,
        codexUrl: process.env.VUE_APP_DEV_CODEX_URL,
        newsletterManagementUrl:
          process.env.VUE_APP_DEV_NEWSLETTER_MANAGEMENT_URL,
        userEditUrl: process.env.VUE_APP_DEV_USER_EDIT_URL,
        gdprEmailContact: process.env.VUE_APP_GDPR_EMAIL_CONTACT,
        loginDarkModeParam: process.env.VUE_APP_LOGIN_NIGHT_MODE_PARAM,
        premiumSubscriptionUrl:
          process.env.VUE_APP_DEV_PREMIUM_SUBSCRIPTION_URL,
        mySubscriptionUrl: process.env.VUE_APP_DEV_MY_SUBSCRIPTION_URL,
      },
    },
    {
      regex: process.env.VUE_APP_STG_APP_HOSTNAME_REGEX,
      configuration: {
        forumUrl: process.env.VUE_APP_STG_CONFIGURATION_HOSTNAME,
        widgetUrl: process.env.VUE_APP_STG_CONFIGURATION_WIDGET_HOSTNAME,
        loginUrl: process.env.VUE_APP_STG_LOGIN_URL,
        subscriptionUrl: process.env.VUE_APP_STG_BUY_SUBSCRIPTION_URL,
        codexUrl: process.env.VUE_APP_STG_CODEX_URL,
        newsletterManagementUrl:
          process.env.VUE_APP_STG_NEWSLETTER_MANAGEMENT_URL,
        userEditUrl: process.env.VUE_APP_STG_USER_EDIT_URL,
        gdprEmailContact: process.env.VUE_APP_GDPR_EMAIL_CONTACT,
        loginDarkModeParam: process.env.VUE_APP_LOGIN_NIGHT_MODE_PARAM,
        premiumSubscriptionUrl:
          process.env.VUE_APP_STG_PREMIUM_SUBSCRIPTION_URL,
        mySubscriptionUrl: process.env.VUE_APP_STG_MY_SUBSCRIPTION_URL,
      },
    },
    {
      regex: process.env.VUE_APP_PROD_APP_HOSTNAME_REGEX,
      configuration: {
        forumUrl: process.env.VUE_APP_PROD_CONFIGURATION_HOSTNAME,
        widgetUrl: process.env.VUE_APP_PROD_CONFIGURATION_WIDGET_HOSTNAME,
        loginUrl: process.env.VUE_APP_PROD_LOGIN_URL,
        subscriptionUrl: process.env.VUE_APP_PROD_BUY_SUBSCRIPTION_URL,
        codexUrl: process.env.VUE_APP_PROD_CODEX_URL,
        newsletterManagementUrl:
          process.env.VUE_APP_PROD_NEWSLETTER_MANAGEMENT_URL,
        userEditUrl: process.env.VUE_APP_PROD_USER_EDIT_URL,
        gdprEmailContact: process.env.VUE_APP_GDPR_EMAIL_CONTACT,
        loginDarkModeParam: process.env.VUE_APP_LOGIN_NIGHT_MODE_PARAM,
        premiumSubscriptionUrl:
          process.env.VUE_APP_PROD_PREMIUM_SUBSCRIPTION_URL,
        mySubscriptionUrl: process.env.VUE_APP_PROD_MY_SUBSCRIPTION_URL,
      },
    },
  ]

  const resolveEnvConfiguration = (host?: string) => {
    const { configuration } = useConfiguration()
    const hostname = host ?? location.hostname

    if (
      envConfiguration.some(endpont => {
        if (hostname.match(endpont.regex)) {
          configuration.envConf.codexUrl = endpont.configuration.codexUrl
          configuration.envConf.loginUrl = endpont.configuration.loginUrl
          configuration.envConf.subscriptionUrl =
            endpont.configuration.subscriptionUrl
          configuration.envConf.forumUrl = endpont.configuration.forumUrl
          configuration.envConf.widgetUrl = endpont.configuration.widgetUrl
          configuration.envConf.loginDarkModeParam =
            endpont.configuration.loginDarkModeParam
          configuration.envConf.newsletterManagementUrl =
            endpont.configuration.newsletterManagementUrl
          configuration.envConf.userEditUrl = endpont.configuration.userEditUrl
          configuration.envConf.gdprEmailContact =
            endpont.configuration.gdprEmailContact
          configuration.envConf.premiumSubscriptionUrl =
            endpont.configuration.premiumSubscriptionUrl
          configuration.envConf.mySubscriptionUrl =
            endpont.configuration.mySubscriptionUrl

          return true
        }
      })
    ) {
      return
    }

    const { appError } = useAppState()
    appError.value = new AppError(APP_ERRORS.ORIGIN_NOT_ALLOWED)
  }

  return {
    resolveEnvConfiguration,
  }
}
